import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { getHttpHeaders } from '@commons/utility/util';

import { environment } from '@environments/environment';

import { ResetPasswordUserResponse } from '@model/resetPasswordUserResponse';
import { ResetPasswordRequest } from '@model/resetPasswordRequest';
import { CustomResponseDto } from '@core/model/custom-response-dto';
import { ResetPasswordResponse } from '@model/resetPasswordResponse';

@Injectable({
  providedIn: 'root',
})
export class ResetPasswordService {
  private apiUrl = environment.apiGatewayUrl;

  private readonly recoverPasswordUrl = `${this.apiUrl}onboarding-service/public/ldap/document/{productId}/{document}`;
  private readonly resetPasswordUrl = `${this.apiUrl}onboarding-service/public/ldap/reset-password`;
  private readonly validTokenUrl = `${this.apiUrl}onboarding-service/public/user_account/validate/token/{token}`;

  private headers = getHttpHeaders();

  constructor(private http: HttpClient) {}

  public postMailEncrypt(productId: string, document: number, token: string): Observable<ResetPasswordResponse> | null {
    return this.http
      .post<any>(
        this.recoverPasswordUrl.replace('{document}', document.toString()).replace('{productId}', productId),
        {
          recaptchaOrigin: 'LOGIN_PAGE',
          recaptchaToken: token,
        },
        { headers: this.headers }
      )
      .pipe(
        map((response: CustomResponseDto<any>) => {
          return response.response;
        })
      );
  }

  public resetPassword(request: ResetPasswordRequest): Observable<ResetPasswordUserResponse> {
    return this.http
      .post(this.resetPasswordUrl, request, {
        headers: this.headers,
      })
      .pipe(
        map((response: CustomResponseDto<any>) => {
          return response.response;
        })
      );
  }

  public validKeyMailPassword(token: string): Observable<any> {
    return this.http.get<any>(this.validTokenUrl.replace('{token}', token), { headers: this.headers }).pipe(
      map((response: CustomResponseDto<any>) => {
        return response.response;
      })
    );
  }
}
